import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import AOS from 'aos';
import LottieAnimations from './components/LottieAnimations';
import Filter from './components/Filter';
import HeroAnimation from './components/HeroAnimation';
import Accordion from './components/Accordion';
import IEcheck from './components/IEcheck';

export class Alfred {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {

		const WIDE_VIEWPORT = 480;
		function resizeVideo(wideViewport) {
			let videoEl = document.getElementById('hero-video');

			if(!videoEl) return;

			let poster = videoEl.dataset.poster;
			let src = videoEl.dataset.srcMobile;

			let widthDisplay = 'MOBILE';

			if (wideViewport.matches) {
				src = videoEl.dataset.srcDesktop;
				poster = videoEl.dataset.poster;
			widthDisplay = 'DESKTOP';
			}
			if (videoEl.src !== src) {
				videoEl.src = src;
				videoEl.poster = poster;
			}
		}
		const wideViewport = window.matchMedia(`(min-width: ${WIDE_VIEWPORT}px)`)
		wideViewport.addListener(resizeVideo)
		resizeVideo(wideViewport)

		AOS.init();
		Menu.init();
		Filter.init();
		HeroAnimation.init();
		Accordion.init();
		LottieAnimations.init();
		this.IEcheck = new IEcheck();


		window.addEventListener('resize', () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		});

		document.dispatchEvent(new Event('bless'));
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();